import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import TableReportPreview from "../../../../components/fragments/admin/report/preview/TableReportPreview";
import TableReportTransportPreview from "../../../../components/fragments/admin/report/preview/TableReportTransportPreview";

export default function IndexPage() {
    return(
        <RootAdmin>
            <Card radius="sm">
                <CardBody>
                    <Tabs
                        color="primary"
                        variant="underlined"
                        aria-label="tabs"
                        classNames={{
                            tabList: "gap-6 w-full relative rounded-none p-0 border-b border-divider",
                            cursor: "w-full",
                            tab: "max-w-fit px-1.5 h-12",
                            tabContent: "group-data-[selected=true]:font-semibold"
                        }}
                    >
                        <Tab key="1" title="Pengangkutan B3">
                            <TableReportTransportPreview/>
                        </Tab>
                        <Tab key="2" title="Pengelolaan B3">
                            <TableReportPreview/>
                        </Tab>
                    </Tabs>
                </CardBody>
            </Card>
        </RootAdmin>
    )
}
